import styled from 'styled-components';
import RevenueWalletIcon from '../Assets/wallet-money.svg';
import { Body1, Body5, H1 } from '../style-comps/Common.styles'

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 16px;
  width: 280px;
  height:200px;
  font-family: 'Arial', sans-serif;
  position: relative;

  @media (max-width: 768px) {
     width:100%;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 60px;
`;

export const RevenueText = styled(Body1)`
  margin: 0;
`;



export const IconWrapper = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 24px;
  height: 24px;
  background-image: url(${RevenueWalletIcon});
  background-size: cover;
  background-repeat: no-repeat;
`;

export const TotalIcon = styled.div`
  width: 12px;
  height: 12px;
  margin-right:6px;
  background-image: url(${RevenueWalletIcon});
  background-size: cover;
  background-repeat: no-repeat;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const RevenueAmountContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: 8px;
`;

export const TotalRevenueText = styled(Body5)`
  color: #666666;
`;

export const RevenueAmount = styled(H1)`
  padding-top: 6px;

  .decimal {
    color: #000;
  }
`;

export const TotalEarnedContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  background-color: #F2F4F8;
  border-radius:32px;
  padding:0 10px;
`;

export const TotalEarnedText = styled(Body5)`
  color: #666666;
`;

export const TotalEarnedAmount = styled(Body5)`
  font-weight: 600;
  color: #61CBC9;
  margin-left: 8px;
`;
